import { render, staticRenderFns } from "./MsgAnalysisText.vue?vue&type=template&id=52ad54c4&"
import script from "./MsgAnalysisText.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisText.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports